import { computed, ref, toValue } from 'vue';

export const useSportLiveTvFilterSearch = (options) => {
  const search = ref('');

  const visibleOptions = computed(() => {
    const query = search.value.trim().toLowerCase();
    const allOptions = toValue(options);

    return query ? allOptions.filter(({ label }) => label.toLowerCase().includes(query)) : allOptions;
  });

  return { search, visibleOptions };
};
